// Static UI metadata for domain-search results.
// Availability, statuses, and results themselves are provided by the backend
// API (/api/search) — this file only holds presentation constants.

export const STATUS_META = {
  available: {
    label: "available",
    color: "#22c55e",
    desc: "This domain is available to register.",
  },
  taken: {
    label: "taken",
    color: "#71717a",
    desc: "This domain is already registered.",
  },
  premium: {
    label: "premium",
    color: "#f59e0b",
    desc: "A premium domain with a higher registration price.",
  },
  marketed: {
    label: "for sale",
    color: "#c084fc",
    desc: "Listed for sale on the domain aftermarket.",
  },
  maybe: {
    label: "maybe",
    color: "#eab308",
    desc: "Availability could not be confirmed.",
  },
  tld: {
    label: "tld",
    color: "#3b82f6",
    desc: "This is a top-level domain.",
  },
};

export const EXAMPLE_QUERIES = [
  "hello",
  "my startup",
  "instagram",
  "del.icio.us",
  "goo.gl",
  "build",
];
